// import { useTheme } from "@emotion/react";
// import { useEffect } from "react";
// import { useForm } from "react-hook-form";
// import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import EditIcon from "@mui/icons-material/Edit";
// import AddIcon from "@mui/icons-material/Add";
// import WSTextField from "../../Components/TextBox/WSTextBox";
// import WSRadioField from "../../Components/Radio/WSRadio";

// // Variant Dialog Component
// interface VariantDialogProps {
//     open: boolean;
//     onClose: () => void;
//     onSave: (data: any) => void;
//     editData?: any;
// }

// const VariantDialog: React.FC<VariantDialogProps> = ({ open, onClose, onSave, editData }) => {
//     const theme = useTheme();
//     const {
//         control,
//         register,
//         handleSubmit,
//         reset,
//         formState: { errors },
//     } = useForm({
//         defaultValues: editData || {
//             variant_code: "",
//             size: "",
//             color: "",
//             other1: "",
//             status: "active",
//         },
//     });

//     useEffect(() => {
//         if (editData) {
//             reset(editData);
//         } else {
//             reset({
//                 variant_code: "",
//                 size: "",
//                 color: "",
//                 other1: "",
//                 status: "active",
//             });
//         }
//     }, [editData, reset]);

//     const onSubmit = (data: any) => {
//         onSave(data);
//         onClose();
//     };

//     return (
//         <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//             <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     {editData ? <EditIcon color="primary" /> : <AddIcon color="primary" />}
//                     <Typography variant="h6">
//                         {editData ? 'Edit Variant' : 'Add New Variant'}
//                     </Typography>
//                 </Box>
//                 <IconButton onClick={onClose} size="small">
//                     <CloseIcon />
//                 </IconButton>
//             </DialogTitle>
//             <form onSubmit={handleSubmit(onSubmit)}>
//                 <DialogContent dividers>
//                     <Grid container spacing={2}>
//                         <Grid item xs={12}>
//                             <WSTextField
//                                 id="variant_code"
//                                 {...register("variant_code", { required: "Variant code is required" })}
//                                 label="Variant Code/SKU"
//                                 control={control}
//                                 required

//                             />
//                         </Grid>
//                         <Grid item xs={12} md={6}>
//                             <WSTextField
//                                 {...register("size")}
//                                 label="Size"
//                                 control={control}
//                                 id="size"
//                             />
//                         </Grid>
//                         <Grid item xs={12} md={6}>
//                             <WSTextField
//                                 {...register("color")}
//                                 label="Color"
//                                 control={control}
//                                 id="color"
//                             />
//                         </Grid>
//                         <Grid item xs={12}>
//                             <WSTextField
//                                 {...register("other1")}
//                                 label="Other Attribute"
//                                 control={control}
//                                 id="other1"
//                             />
//                         </Grid>
//                         <Grid item xs={12}>
//                             <WSRadioField
//                                 id="status"
//                                 {...register("status")}
//                                 label="Status"
//                                 control={control}
//                                 options={[
//                                     { value: "active", label: "Active" },
//                                     { value: "inactive", label: "Inactive" },
//                                 ]}
//                                 rules={{ required: true }}
//                             />
//                         </Grid>
//                     </Grid>
//                 </DialogContent>
//                 <DialogActions sx={{ p: 2 }}>
//                     <Button onClick={onClose} variant="outlined">
//                         Cancel
//                     </Button>
//                     <Button type="submit" variant="contained" color="primary">
//                         {editData ? 'Update' : 'Add'} Variant
//                     </Button>
//                 </DialogActions>
//             </form>
//         </Dialog>
//     );
// };

// export default VariantDialog;




// import React, { useEffect } from "react";
// import { useForm } from "react-hook-form";
// import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import EditIcon from "@mui/icons-material/Edit";
// import AddIcon from "@mui/icons-material/Add";
// import WSTextField from "../../Components/TextBox/WSTextBox";
// import WSRadioField from "../../Components/Radio/WSRadio";

// interface VariantDialogProps {
//     open: boolean;
//     onClose: () => void;
//     onSave: (data: any) => void;
//     editData?: any;
// }

// const VariantDialog: React.FC<VariantDialogProps> = ({ open, onClose, onSave, editData }) => {
//     const {
//         control, handleSubmit, reset, formState: { errors },
//     } = useForm({
//         defaultValues: {
//             variant_code: "",
//             size: "",
//             color: "",
//             other1: "",
//             status: "active",
//         },
//     });

//     useEffect(() => {
//         if (open) {
//             reset({
//                 variant_code: editData?.variant_code || "",
//                 size: editData?.size || "",
//                 color: editData?.color || "",
//                 other1: editData?.other1 || "",
//                 status: editData?.status || "active",
//             });
//         }
//     }, [open, editData, reset]);

//     const onSubmit = (data: any) => {
//         onSave(data);
//     };

//     return (
//         <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//             <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                     {editData ? <EditIcon color="primary" /> : <AddIcon color="primary" />}
//                     <Typography variant="h6">{editData ? 'Edit Variant' : 'Add Variant'}</Typography>
//                 </Box>
//                 <IconButton onClick={onClose} size="small">
//                     <CloseIcon />
//                 </IconButton>
//             </DialogTitle>
//             <form onSubmit={handleSubmit(onSubmit)}>
//                 <DialogContent dividers>
//                     <Grid container spacing={2}>
//                         {/* ✅ FIXED: No error/helperText props */}
//                         <Grid item xs={12}>
//                             <WSTextField
//                                 name="variant_code"
//                                 id="variant_code"
//                                 label="Variant Code *"
//                                 control={control}
//                                 rules={{ required: "Variant code required" }}
//                             />
//                         </Grid>
//                         <Grid item xs={6}>
//                             <WSTextField 
//                                 name="size" 
//                                 id="size" 
//                                 label="Size" 
//                                 control={control} 
//                             />
//                         </Grid>
//                         <Grid item xs={6}>
//                             <WSTextField 
//                                 name="color" 
//                                 id="color" 
//                                 label="Color" 
//                                 control={control} 
//                             />
//                         </Grid>
//                         <Grid item xs={12}>
//                             <WSTextField 
//                                 name="other1" 
//                                 id="other1" 
//                                 label="Other Attribute" 
//                                 control={control} 
//                             />
//                         </Grid>
//                         <Grid item xs={12}>
//                             <WSRadioField
//                                 name="status"
//                                 id="status"
//                                 label="Status"
//                                 control={control}
//                                 rules={{ required: true }}
//                                 options={[
//                                     { value: "active", label: "Active" },
//                                     { value: "inactive", label: "Inactive" },
//                                 ]}
//                             />
//                         </Grid>
//                     </Grid>
//                 </DialogContent>
//                 <DialogActions sx={{ p: 2 }}>
//                     <Button onClick={onClose} variant="outlined">Cancel</Button>
//                     <Button type="submit" variant="contained" color="primary">
//                         {editData ? 'Update' : 'Add'} Variant
//                     </Button>
//                 </DialogActions>
//             </form>
//         </Dialog>
//     );
// };

// export default VariantDialog;


import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSRadioField from "../../Components/Radio/WSRadio";

interface VariantDialogProps {
    open: boolean;
    onClose: () => void;
    onSave: (data: any) => void;
    editData?: any;
}

const VariantDialog: React.FC<VariantDialogProps> = ({ open, onClose, onSave, editData }) => {
    const { control, handleSubmit, reset } = useForm({
        defaultValues: {
            variant_code: "",
            size: "",
            color: "",
            other1: "",
            stock_qty: 0,
            status: "active",
        },
    });

    useEffect(() => {
        if (open) {
            reset({
                variant_code: editData?.variant_code || "",
                size: editData?.size || "",
                color: editData?.color || "",
                other1: editData?.other1 || "",
                status: editData?.status || "active",
                stock_qty: editData?.stock_qty || 0,
            });
        }
    }, [open, editData, reset]);

    const onSubmit = (data: any) => {
        onSave(data);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {editData ? <EditIcon color="primary" /> : <AddIcon color="primary" />}
                    <Typography variant="h6">{editData ? 'Edit Variant' : 'Add Variant'}</Typography>
                </Box>
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        {/* ALL FIELDS WITH REQUIRED 'id' PROP */}
                        <Grid item xs={12}>
                            <WSTextField
                                id="variant-code-field"
                                name="variant_code"
                                label="Variant Code *"
                                control={control}
                                rules={{ required: "Variant code required" }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <WSTextField
                                id="size-field"
                                name="size"
                                label="Size"
                                control={control}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <WSTextField
                                id="color-field"
                                name="color"
                                label="Color"
                                control={control}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <WSTextField
                                id="stock-qty-field"
                                name="stock_qty"
                                label="Stock Quantity"
                                type={TextType.AllowOnlyNumber}
                                control={control}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <WSTextField
                                id="other-attr-field"
                                name="other1"
                                label="Other Attribute"
                                control={control}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <WSRadioField
                                id="status-variant-field"
                                name="status"
                                label="Status"
                                control={control}
                                rules={{ required: true }}
                                options={[
                                    { value: "active", label: "Active" },
                                    { value: "inactive", label: "Inactive" },
                                ]}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions sx={{ p: 2 }}>
                    <Button onClick={onClose} variant="outlined">Cancel</Button>
                    <Button type="submit" variant="contained" color="primary">
                        {editData ? 'Update' : 'Add'} Variant
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default VariantDialog;
